module.exports = __webpack_public_path__ + "media/client/assets/logo-7d59a605ee5baff5fb59e1b5eaa533b1.png";